export function t(text, values) {
    if (!values)
        return text;
    return text.replace(/\{(\w+)\}/g, (_, k) => String(values[k]));
}
